import { User } from '@app/core/models';
import { UserActions, UserActionTypes } from '../actions/user.actions';

/**
 * UserState
 */
export interface UserState {
  loaded: boolean;
  pending: boolean;
  error: any;
  profile: User;
}

/**
 * USER_INITIAL_STATE
 * @type {{loaded: boolean; pending: boolean; error: null; profile: null}}
 */
export const USER_INITIAL_STATE: UserState = {
  loaded: false,
  pending: false,
  error: null,
  profile: {
    theme: 'theme-one-portal',
    logo: 'assets/images/essilor-logo-white.svg',
  },
};
/**
 * userReducer
 * @param {UserState} state
 * @param {UserActions} action
 * @returns {UserState}
 */
export const userReducer = (
  state: UserState = USER_INITIAL_STATE,
  action: UserActions,
): UserState => {
  switch (action.type) {
    case UserActionTypes.LOAD_USER:
      return {
        ...state,
        error: null,
        loaded: false,
        pending: true,
      };
    case UserActionTypes.LOAD_USER_SUCCESS:
      return {
        ...state,
        loaded: true,
        pending: false,
        profile: { ...state.profile, ...action.payload },
      };
    case UserActionTypes.LOAD_USER_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};
